import { defineComponent as m, inject as h, computed as d, h as i } from "vue";
import { menuInjectionKey as p } from "./ghl-ui.es1045.js";
import { render as l } from "./ghl-ui.es985.js";
import x from "./ghl-ui.es862.js";
import f from "./ghl-ui.es1496.js";
const w = m({
  name: "MenuOptionContent",
  props: {
    collapsed: Boolean,
    disabled: Boolean,
    title: [String, Function],
    icon: Function,
    extra: [String, Function],
    showArrow: Boolean,
    childActive: Boolean,
    hover: Boolean,
    paddingLeft: Number,
    selected: Boolean,
    maxIconSize: {
      type: Number,
      required: !0
    },
    activeIconSize: {
      type: Number,
      required: !0
    },
    iconMarginRight: {
      type: Number,
      required: !0
    },
    clsPrefix: {
      type: String,
      required: !0
    },
    onClick: Function,
    tmNode: {
      type: Object,
      required: !0
    },
    isEllipsisPlaceholder: Boolean
  },
  setup(e) {
    const {
      props: n
    } = h(p);
    return {
      menuProps: n,
      style: d(() => {
        const {
          paddingLeft: t
        } = e;
        return {
          paddingLeft: t && `${t}px`
        };
      }),
      iconStyle: d(() => {
        const {
          maxIconSize: t,
          activeIconSize: r,
          iconMarginRight: o
        } = e;
        return {
          width: `${t}px`,
          height: `${t}px`,
          fontSize: `${r}px`,
          marginRight: `${o}px`
        };
      })
    };
  },
  render() {
    const {
      clsPrefix: e,
      tmNode: n,
      menuProps: {
        renderIcon: t,
        renderLabel: r,
        renderExtra: o,
        expandIcon: s
      }
    } = this, a = t ? t(n.rawNode) : l(this.icon);
    return i("div", {
      onClick: (u) => {
        var c;
        (c = this.onClick) === null || c === void 0 || c.call(this, u);
      },
      role: "none",
      class: [`${e}-menu-item-content`, {
        [`${e}-menu-item-content--selected`]: this.selected,
        [`${e}-menu-item-content--collapsed`]: this.collapsed,
        [`${e}-menu-item-content--child-active`]: this.childActive,
        [`${e}-menu-item-content--disabled`]: this.disabled,
        [`${e}-menu-item-content--hover`]: this.hover
      }],
      style: this.style
    }, a && i("div", {
      class: `${e}-menu-item-content__icon`,
      style: this.iconStyle,
      role: "none"
    }, [a]), i("div", {
      class: `${e}-menu-item-content-header`,
      role: "none"
    }, this.isEllipsisPlaceholder ? this.title : r ? r(n.rawNode) : l(this.title), this.extra || o ? i("span", {
      class: `${e}-menu-item-content-header__extra`
    }, " ", o ? o(n.rawNode) : l(this.extra)) : null), this.showArrow ? i(x, {
      ariaHidden: !0,
      class: `${e}-menu-item-content__arrow`,
      clsPrefix: e
    }, {
      default: () => s ? s(n.rawNode) : i(f, null)
    }) : null);
  }
});
export {
  w as default
};
